import axios from "axios";


const bdaxios = axios.create({
    baseURL: process.env.REACT_APP_BASEURL,
});

export class Usuario{

    id=''
    nombre= ""
    password= ""
    alias=''
    nivel=5


    async getUsers() {
        try {
            const res = await bdaxios({
                method:'GET',
                url: '/users',
            });
            return res.data;

        } catch (error) {
            console.log(error.message)
            throw error
        }

    }

    async addUser(user, token) {
        try {   
            console.log(user)  
            await bdaxios({
                method: 'POST',
                url: '/users',
                headers: {
                    Authorization: 'Bearer ' + token.value,
                },
                data: user
            });
            return this.getUsers();
        } catch (error) {
            throw error
        }
    }

    async updateUser(user, token) {
        await bdaxios({
            method: 'PATCH',
            url: '/users/' + user.id,
            headers: {
                Authorization: 'Bearer ' + token.value,
            },
            data: user
        });
        return this.getUsers();
    }

    async delUser(id, token) {
        await bdaxios({
            method: 'DELETE',
            url: '/users/' + id,
            headers: {
                Authorization: 'Bearer ' + token.value,
            },
        });
        return this.getUsers();
    }
}
